<template>
  <section class="colored section" style="background: #ffffffa0;">
    <div class="columns is-centered">
      <div
        class="column is-6-desktop is-10-tablet is-12-mobile"
        id="campos-signup"
      >
        <b-loading
          :is-full-page="true"
          :active.sync="isLoading"
          :can-cancel="false"
        ></b-loading>
        <h1 class="title">{{ $t('Estimado solicitante') }},</h1>
        <p>{{ $t('NF3SU1') }}</p>

        <br />
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(validateBeforeSubmit)">
            <b-field grouped group-multiline class="">
              <b-field expanded :label="`${$t('Nombre')}*`">
                <ValidationProvider
                  :name="$t('Nombre')"
                  rules="required|alpha_spaces"
                  v-slot="{ errors }"
                >
                  <b-input
                    :placeholder="`${$t('Nombre')}*`"
                    icon="account"
                    v-model="newUserData.firstName"
                  ></b-input>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </b-field>

              <b-field expanded :label="`${$t('Apellidos')}*`">
                <ValidationProvider
                  :name="$t('Apellidos')"
                  rules="required|alpha_spaces"
                  v-slot="{ errors }"
                >
                  <b-input
                    :placeholder="`${$t('Apellidos')}*`"
                    icon="account"
                    v-model="newUserData.lastName"
                  ></b-input>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </b-field>

              <b-field expanded :label="`${$t('Empresa')}*`">
                <ValidationProvider
                  :name="$t('Empresa')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-input
                    :placeholder="`${$t('Empresa')}*`"
                    icon="account"
                    v-model="newUserData.companyName"
                  ></b-input>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </b-field>
              <b-field expanded :label="`${$t('Cargo')}*`">
                <ValidationProvider
                  :name="$t('Cargo')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-input
                    :placeholder="`${$t('Cargo')}*`"
                    icon="account"
                    v-model="newUserData.jobPosition"
                  ></b-input>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </b-field>

              <b-field expanded :label="`${$t('Sede comercial')}*`">
                <ValidationProvider
                  :name="$t('Sede comercial')"
                  rules="required|alpha_spaces"
                  v-slot="{ errors }"
                >
                  <b-input
                    :placeholder="`${$t('Sede comercial')}*`"
                    icon="account"
                    v-model="newUserData.city"
                  ></b-input>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </b-field>
              <b-field expanded :label="`${$t('Juriscicción / País')}*`">
                <country-selector
                  :placeholder="$t('Jurisdicción / País')"
                  v-model="newUserData.country"
                  class="country-selector"
                />
              </b-field>

              <b-field expanded :label="`${$t('Teléfono')}*`">
                <VuePhoneNumberInput dir="ltr" v-model="newUserData.phone" />
              </b-field>
              <b-field expanded :label="`${$t('Website')}`">
                <b-input
                  placeholder="Website"
                  icon="web"
                  v-model="newUserData.website"
                ></b-input>
              </b-field>

              <b-field expanded :label="`${$t('Linkedin')}`">
                <b-input
                  placeholder="Linkedin"
                  icon="account-group"
                  v-model="newUserData.socialNetwork"
                ></b-input>
              </b-field>
              <b-field expanded :label="`${$t('Mail de contacto')}*`">
                <ValidationProvider
                  :name="$t('Mail contacto')"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <b-input
                    :placeholder="$t('Mail contacto')"
                    icon="email"
                    disabled
                    v-model="email"
                  ></b-input>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </b-field>
              <ValidationProvider
                name="Terminos de uso"
                rules="required"
                v-slot="{ errors }"
                style="margin: auto;"
              >
              <br>
                <b-checkbox v-model="terms">
                  <a
                    href="https://ecobanka.com/privacy-policy%E2%80%8B/"
                    target="_blank"
                  >&nbsp
                    {{
                      $t(
                        'Acepto la Política de Privacidad, Términos y Condiciones'
                      )
                    }}</a
                  >*
                </b-checkbox>
                <p v-show="errors.length" class="help is-danger">
                  {{ $t('Debes aceptar los términos y condiciones') }}
                </p>
              </ValidationProvider>
            </b-field>
            </br>
            <div class="">
              <p>
                {{ $t('Incluir los emails de compañeros y partners para que estén en copia a partir de este momento.' )}}
              </p>
              <emails-input :value="newUserData.collaboratorEmails" />

              <b-field grouped group-multiline class="">
                <b-button
                  @click="goToCalendly()"
                  style="margin: auto; margin-bottom: 10px;"
                  size="is-large"
                  type="is-pink"
                >
                  {{ $t('Solicitar reunión corporativa') }}
                </b-button>
                <b-button
                  style="margin: auto; margin-bottom: 10px;"
                  native-type="submit"
                  size="is-large"
                  type="is-primary"
                  >{{ $t('Registrarme y continuar') }}</b-button
                >
              </b-field>
            </div>

          </form>
        </ValidationObserver>
      </div>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import CountrySelector from '@/components/common/CountrySelector'
import EmailsInput from '@/components/common/EmailsInput'
import Fetcher from '@/mixins/fetcher.js'
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import { required, alpha_spaces, email } from 'vee-validate/dist/rules'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

extend('required', {
  ...required
})

extend('email', {
  ...email
})

extend('alpha_spaces', {
  ...alpha_spaces
})

export default {
  mixins: [Fetcher],
  components: {
    ValidationProvider,
    ValidationObserver,
    CountrySelector,
    EmailsInput,
    VuePhoneNumberInput
  },
  data() {
    return {
      email: null,
      requestId: null,
      terms: null,
      newUserData: {
        firstName: null,
        lastName: null,
        jobPosition: null,
        companyName: null,
        city: null,
        country: null,
        phone: ' - ',
        website: null,
        socialNetwork: null,
        collaboratorEmails: []
      }
    }
  },
  mounted() {
    this.email = this.$store.state.onBoard.neofintech.email
    this.requestId = this.$store.state.onBoard.neofintech.requestId
    this.newUserData.country = this.$store.state.onBoard.neofintech.phase1.companyLocations[0]
  },
  computed: {},
  methods: {
    ...mapActions('onBoard', ['postOnboardRequestSignup']),
    validateBeforeSubmit() {
      this.signUp()
    },
    signUp: function() {
      let self = this
      self.request(() =>
        self
          .postOnboardRequestSignup({
            requestId: self.requestId,
            collaboratorEmails: self.newUserData.collaboratorEmails,
            attributes: {
              lang: self.$i18n.locale,
              email: self.email,
              firstName: self.newUserData.firstName,
              lastName: self.newUserData.lastName,
              companyName: self.newUserData.companyName,
              jobPosition: self.newUserData.jobPosition,
              city: self.newUserData.city,
              country: self.$t(self.newUserData.country),
              telephone: self.newUserData.phone,
              website: self.newUserData.website,
              socialNetwork: self.newUserData.socialNetwork
            }
          })
          .then(function(response) {
            self.$store.commit('onBoard/SET_NEOFINTECH_USER_DATA', response)
            self.$router.push({ name: 'onBoard.neofintech.phase3.actions' })
          })
      )
    },
    goToCalendly: function() {
      const widget = document.getElementsByClassName(
        'calendly-badge-content'
      )[0]
      widget.click()
      //window.open('https://myneofintech.com/myneofintech/conference/', '_blank')
    }
  }
}
</script>

<style lang="scss">
#campos-signup {
  .field.is-grouped-multiline {
    width: 100%;

    .field {
      margin-bottom: 20px;
      width: 48%;
      min-width: 250px;
      flex-grow: 1;
    }
  }
  .control {
    box-shadow: 0 8px 10px -7px #00000055;
  }
  .input {
    border-radius: 10px 10px 5px 5px !important;
  }

  /*Fix ancho pais selector */ 
  .country-selector span.select {
    width: 100%;

    select {
      width: 100%;
    }
  }
}
</style>
